import React, { useState } from 'react'
import Bredcrumb from '../Common/Bredcrumb'
import {} from 'react-router-dom'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
const SportsMeet = () => {

    const images = [
        'img/content/SportsFeild-01.png',
        'img/content/SportsFeild-02.png',
        'img/content/SportsFeild-03.png',
        'img/content/SportsFeild-04.png',
        'img/content/SportsFeild-05.png',
        'img/content/SportsFeild-06.png',
        'img/content/SportsFeild-07.png',
        'img/content/SportsFeild-08.png',
        'img/content/SportsFeild-09.png',
        'img/content/SportsFeild-10.png',
        'img/content/SportsFeild-11.png',
        'img/content/SportsFeild-12.png',
        'img/content/SportsFeild-13.png',
        'img/content/SportsFeild-14.png',
        'img/content/SportsFeild-15.png',      
        'img/content/SportsFeild-17.png',
        'img/content/SportsFeild-18.png',
        'img/content/SportsFeild-19.png',
        'img/content/SportsFeild-20.png',
        'img/content/SportsFeild-21.png',
        'img/content/SportsFeild-22.png',
        'img/content/SportsFeild-23.png',
        'img/content/SportsFeild-24.png',
        'img/content/SportsFeild-25.png',
        'img/content/SportsFeild-26.png',
        'img/content/SportsFeild-27.png',
        'img/content/SportsFeild-28.png',
        'img/content/SportsFeild-29.png',
        'img/content/SportsFeild-30.png',
        'img/content/SportsFeild-31.png',
        'img/content/SportsFeild-32.png',
        'img/content/SportsFeild-33.png',
        'img/content/SportsFeild-34.png',
        'img/content/SportsFeild-35.png',
        'img/content/SportsFeild-36.png',
        'img/content/SportsFeild-37.png',
        'img/content/SportsFeild-38.png',
        'img/content/SportsFeild-39.png',
        'img/content/SportsFeild-40.png',
        'img/content/SportsFeild-41.png',
        'img/content/SportsFeild-42.png',
        'img/content/SportsFeild-43.png',
        'img/content/SportsFeild-44.png',
        'img/content/SportsFeild-45.png',
        'img/content/SportsFeild-46.png',
        'img/content/SportsFeild-47.png',
        'img/content/SportsFeild-48.png',
        'img/content/SportsFeild-49.png',
       ];
    
      const [isOpen, setIsOpen] = useState(false);
      const [photoIndex, setPhotoIndex] = useState(0);
      const [loading, setLoading] = useState(false);
    
      const openLightbox = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
        setLoading(true);
      };
    
      const closeLightbox = () => {
        setIsOpen(false);
        setLoading(false);
      };
    
      const onImageLoad = () => {
        setLoading(false);
      };

      
  return (
    <>
      <Bredcrumb title="Sports Meet" />
      <section className="facility-box mt-4">
        <div className="container">          
          <div className="row mb-4">
                    <div className="col-md-12">
                            <div className="gallery text-center row">
                            {images.map((image, index) => (
                            <div key={index} className="col-md-4 mb-4">
                                <div className='gallery-block'>
                                    <img src={image} alt={`Image ${index + 1}`} onClick={() => openLightbox(index)} style={{cursor: 'pointer' }} />
                                </div>
                            </div>
                            ))}
                            {isOpen && (
                                <Lightbox
                                    mainSrc={images[photoIndex]}
                                    nextSrc={images[(photoIndex + 1) % images.length]}
                                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                    onCloseRequest={closeLightbox}
                                    onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
                                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
                                    imageLoadErrorHandler={() => setLoading(false)}
                                    onImageLoad={onImageLoad}
                                />
                            )}
                            {loading && <div className="loading-indicator">Loading...</div>}

                               
                            </div>
                    </div>
                </div>	           
          </div>
        </section>
    </>
  )
}

export default SportsMeet
